// ========== STATE MANAGEMENT ==========
const state = {
    balance: pointsEarnedDisplay,
    pointsEarned: pointsEarnedDisplay,
    minRedeem: 100,
    minTransfer: 100,
    usedCodes: new Set(),
    currentRedeemType: null,
    friendLookupDemo: {},
    recipient: { checked: false, phone: '', registered: false, name: '', nameMasked: '' }
};

// ========== UTILITY FUNCTIONS ==========
function formatNumber(n) { 
    return n.toLocaleString('en-US'); 
}

function hideElements(...elements) {
    elements.forEach(el => {
        if (el) el.classList.add('np-hidden');
    });
}

function showElements(...elements) {
    elements.forEach(el => {
        if (el) el.classList.remove('np-hidden');
    });
}

function toLatinDigits(s) {
    return s
        .replace(/[\u0660-\u0669]/g, c => String.fromCharCode(c.charCodeAt(0) - 0x0660 + 48))
        .replace(/[\u06F0-\u06F9]/g, c => String.fromCharCode(c.charCodeAt(0) - 0x06F0 + 48));
}

function digitsOnly(s) { 
    return toLatinDigits(s).replace(/\D+/g, ''); 
}

function bindDigitsOnly(id) {
    const el = document.getElementById(id);
    if (!el) return;
    el.setAttribute('inputmode', 'numeric');
    el.setAttribute('pattern', '[0-9]*');
    el.setAttribute('dir', 'ltr');
    el.addEventListener('input', () => {
        const cleaned = digitsOnly(el.value);
        if (el.value !== cleaned) el.value = cleaned;
    });
}

function genTxnId(prefix = 'TX') {
    return `${prefix}-${Math.random().toString(36).slice(2, 6).toUpperCase()}-${Date.now().toString().slice(-5)}`;
}

function validateMinimumPoints(points, minimum, errorEl, errorMsg) {
    if (points > 0 && points < minimum) {
        if (errorEl) {
            errorEl.textContent = errorMsg || `Minimum is ${minimum} points.`;
            showElements(errorEl);
        }
        return false;
    }
    if (errorEl) hideElements(errorEl);
    return true;
}


// ========== UI UPDATE FUNCTIONS ==========
function refreshTop(newBalance) {
    document.getElementById('pointsEarnedDisplay').textContent = formatNumber(newBalance);
    document.getElementById('balanceDisplay').textContent = formatNumber(newBalance);
    getTransaction();
    getNotifications();
}



// ========== INSTAPAY HANDLE FUNCTIONS ==========
const textToAdd = "@instapay";
const input = document.getElementById("instaHandle");

function lockEnding() {
    if (input.value === "") return;
    if (!input.value.endsWith(textToAdd)) {
        input.value = input.value.replace(new RegExp(textToAdd + "$"), "") + textToAdd;
    }
    const pos = input.value.length - textToAdd.length;
    input.setSelectionRange(pos, pos);
}

// ========== REDEEM FUNCTIONS ==========
const redeemPointsInput = document.getElementById('redeemPoints');
const pointsErr = document.getElementById('points-error');
const totalValSpan = document.getElementById('value');
const btnStore = document.getElementById('btn-store');
const btnCoupon = document.getElementById('btn-coupon');
const btnConfirm = document.getElementById('confirm-button');
const siteRow = document.getElementById('site-row');
const siteSelect = document.getElementById('site-select');
const confirmBar = document.getElementById('confirm-bar');
const confirmMsg = document.getElementById('confirm-msg');
const confirmYes = document.getElementById('confirm-yes');
const confirmCancel = document.getElementById('confirm-cancel');
const couponBox = document.getElementById('coupon-box');
const couponCodeEl = document.getElementById('coupon-code');
const couponMeta = document.getElementById('coupon-meta');
const couponLink = document.getElementById('coupon-link');
const copyCouponBtn = document.getElementById('copy-coupon');
const storeBox = document.getElementById('store-box');
const storeCodeEl = document.getElementById('store-code');
const storeMeta = document.getElementById('store-meta');
const storeBarcode = document.getElementById('store-barcode');
const copyStoreBtn = document.getElementById('copy-store');
let selectedValue;

function hideRedeemOutputs() {
    hideElements(couponBox, storeBox, confirmBar);
}

function validatePointsField() {
    hideElements(pointsErr);
    let val = parseInt(redeemPointsInput.value || '0', 10);
    
    if (!val) {
        totalValSpan.textContent = '0';
        btnStore.disabled = true; 
        btnCoupon.disabled = true; 
        btnConfirm.disabled = true;
        pointsErr.textContent = 'Please enter the number of points.';
        showElements(pointsErr);
        return false;
    }
    
    if (!validateMinimumPoints(val, state.minRedeem, pointsErr, `Minimum redeem is ${state.minRedeem} points.`)) {
        totalValSpan.textContent = '0';
        btnStore.disabled = true; 
        btnCoupon.disabled = true; 
        btnConfirm.disabled = true;
        return false;
    }

    val = clampToBalance(val, redeemPointsInput, pointsErr);
    
    totalValSpan.textContent = formatNumber(val);
    btnStore.disabled = false; 
    btnCoupon.disabled = false;
    btnConfirm.disabled = (state.currentRedeemType === null);
    return true;
}

function genEAN13(redeem_code) {
    let base = '';
    for (let i = 0; i < 12; i++) base += Math.floor(Math.random() * 10);
    
    const digits = base.split('').map(d => parseInt(d, 10));
    let sum = 0;
    for (let i = 0; i < 12; i++) {
        sum += (i % 2 === 0) ? digits[i] : digits[i] * 3;
    }
    const check = (10 - (sum % 10)) % 10;
    const code = base + check.toString();
    
    if (state.usedCodes.has(code)) return genEAN13();
    state.usedCodes.add(code);
    return code;
}

function genShopifyCoupon(len = 10) {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    let c = '';
    for (let i = 0; i < len; i++) c += chars[Math.floor(Math.random() * chars.length)];
    const code = 'NP-' + c;
    if (state.usedCodes.has(code)) return genShopifyCoupon(len);
    state.usedCodes.add(code);
    return code;
}

function copyToClipboard(txt) {
    navigator.clipboard?.writeText(txt);
}

function dispatchChange(select) {
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
}

function selectByIndex(select, index) {
    if (index >= 0 && index < select.options.length) {
        select.selectedIndex = index;
        dispatchChange(select);
    } else {
        console.warn('Index out of range:', index);
    }
}

function confirmRedeem() {
    if (!validatePointsField()) return;
    
    if (!state.currentRedeemType) {
        pointsErr.textContent = 'Please choose In-Store or Create Coupon.';
        showElements(pointsErr);
        return;
    }
    
    const pts = parseInt(redeemPointsInput.value, 10);
    const egp = pts;
    
    if (state.currentRedeemType === 'store') {
        confirmMsg.textContent = `Redeem ${formatNumber(pts)} points In-Store (value ${formatNumber(egp)} EGP)?`;
    } else {
        confirmMsg.textContent = `Create website coupon worth ${formatNumber(egp)} EGP (${formatNumber(pts)} points)?`;
    }
    showElements(confirmBar);
}

function processInStoreRedeem(redeem_code, pts, egp, newBalance) {
     const ean = genEAN13(redeem_code);

    
    storeCodeEl.textContent = redeem_code;
    storeMeta.textContent = `Present this code at checkout. Value: ${formatNumber(egp)} EGP`;
    showElements(storeBox);
    hideElements(couponBox);
    
    if (window.JsBarcode) {
        JsBarcode(storeBarcode, redeem_code, { 
            format: 'CODE128', 
            displayValue: false, 
            width: 3, 
            height: 120, 
            margin: 10 
        });
    }
    
    state.balance -= pts;
    state.pointsEarned -= pts;
    refreshTop(newBalance);    
}

// ========== TRANSFER FUNCTIONS ==========
const panelFriend = document.getElementById('panel-friend');
const phoneInput = document.getElementById('transferPhone2');
const checkBtn = document.getElementById('btn-check-transfer2');
const statusP = document.getElementById('transfer-status2');
const nameRow = document.getElementById('transfer-name-row2');
const nameInput = document.getElementById('transferName2');
const notRegAlert = document.getElementById('not-registered-alert');
const ptsInputFriend = document.getElementById('transferPoints2');
const transferTotalRow = document.getElementById('transferTotalRow');
const errFriend = document.getElementById('transfer-error');
const resFriend = document.getElementById('transfer-result');
const btnTransfer = document.getElementById('btn-transfer');
const transferValueEl = document.getElementById('transferValue');
const nameErr = document.getElementById('transfer-name-error');

ptsInputFriend.addEventListener('input', () => {
    let val = ptsInputFriend.value;
    // If starts with multiple zeros (like 00, 01, 002), remove leading zeros
    if (/^0\d+/.test(val)) {
        val = val.replace(/^0+/, ''); 
    }

    // If empty after removing zeros, set to "0"
    if (val === '' || val === '.') {
        val = '0';
    }

    // If starts with dot like ".5", make it "0.5"
    if (val.startsWith('.')) {
        val = '0' + val;
    }

    ptsInputFriend.value = val;
});

redeemPointsInput.addEventListener('input', () => {

    let val = redeemPointsInput.value;

    // If starts with multiple zeros (like 00, 01, 002), remove leading zeros
    if (/^0\d+/.test(val)) {
        val = val.replace(/^0+/, ''); 
    }

    // If empty after removing zeros, set to "0"
    if (val === '' || val === '.') {
        val = '0';
    }

    // If starts with dot like ".5", make it "0.5"
    if (val.startsWith('.')) {
        val = '0' + val;
    }

    redeemPointsInput.value = val;
});


function maskName(full) {
    if (!full || typeof full !== 'string') return 'Unknown';
    
    const parts = full.trim().split(/\s+/);
    if (!parts.length) return 'Unknown';
    
    const first = parts[0];
    if (parts.length >= 2) {
        const secondInitial = (parts[1][0] || '').toUpperCase();
        return `${first} ${secondInitial}***`.trim();
    }
    
    return `${first.slice(0, 3)}***`;
}



function getRegistration(num) {
    

    return checkUser(num)
        .then(data => {
            return { 
                ok: true, 
                registered: true, 
                name: data.name 
            };
        })
        .catch(error => {
            console.error("Error:", error);
            return { ok: false, msg: 'API error.' };
        });
}

function resetFriendTransferForm() {
    phoneInput.value = '';
    nameInput.value = '';
    ptsInputFriend.value = '';
    
    if (transferValueEl) transferValueEl.textContent = '0';
    
    hideElements(nameErr, errFriend, notRegAlert, nameRow, btnTransfer, ptsInputFriend, transferTotalRow);
    
    statusP.textContent = '';
    btnTransfer.disabled = true;
    
    state.recipient = { checked: false, phone: '', registered: false, name: '', nameMasked: '' };
    
    if (typeof updateTransferCTA === 'function') updateTransferCTA();
}

function updateTransferCTA() {
    let pts = parseInt(ptsInputFriend.value, 10) || 0;
    const name = (nameInput.value || '').trim();
    
    const checked = !!(state.recipient && state.recipient.checked);
    if (!checked) {
        btnTransfer.disabled = true;
        return;
    }
    
    const needName = !state.recipient.registered;
    const nameOk = name.length >= 2;
    
    if (needName && !nameOk) {
        nameErr.textContent = "Please enter your friend's full name.";
        showElements(nameErr);
    } else {
        hideElements(nameErr);
    }
    
    const valid = needName ? (pts > 0 && nameOk) : (pts > 0);
    btnTransfer.disabled = !valid;
}

function validateFriendPoints() {
    hideElements(errFriend);
    let pts = parseInt(ptsInputFriend.value || '0', 10);
    
    if (!pts) {
        errFriend.textContent = 'Please enter the number of points.';
        showElements(errFriend);
        return false;
    }
    
    if (!validateMinimumPoints(pts, state.minTransfer, errFriend, `Minimum transfer is ${state.minTransfer} points.`)) {
        return false;
    }
    
    clampToBalance(pts, ptsInputFriend, errFriend);
    return true;
}





// ========== EVENT LISTENERS ==========

hideRedeemOutputs();

function showTxt(){
    document.querySelector('.np-show-ban').classList.remove("np-hidden");
}

function removeTxt(){
    document.querySelector('.np-show-ban').classList.add("np-hidden");
}

// Redeem Points Events
redeemPointsInput.addEventListener('input', () => {


    hideRedeemOutputs();
    state.currentRedeemType = null;
    hideElements(siteRow);
    btnStore.classList.remove('active');
    btnCoupon.classList.remove('active');
    validatePointsField();
});

btnStore.addEventListener('click', () => {
    if (!validatePointsField()) return;
    state.currentRedeemType = 'store';
    btnStore.classList.add('active');
    btnCoupon.classList.remove('active');
    hideElements(siteRow);
    btnConfirm.disabled = false;
    hideRedeemOutputs();
    showTxt();
});

btnCoupon.addEventListener('click', () => {
    if (!validatePointsField()) return;
    state.currentRedeemType = 'coupon';
    btnCoupon.classList.add('active');
    btnStore.classList.remove('active');
    showElements(siteRow);
    btnConfirm.disabled = false;
    hideRedeemOutputs();
    removeTxt();
});

btnConfirm?.addEventListener('click', confirmRedeem);
confirmCancel.addEventListener('click', () => hideElements(confirmBar));

confirmYes.addEventListener('click', () => {
    hideElements(confirmBar);
    const pts = parseInt(redeemPointsInput.value, 10);
    const egp = pts;
    
    if (state.currentRedeemType === 'store') {
        redeemPointsOffline(pts)
            .then(data => {
                processInStoreRedeem(data.cardNo, pts, egp, data.newBalance);
            })
            .catch(error => {
                console.error("Error:", error);
            });
    } else {
        let select_site = document.getElementById("site-select");
        selectedValue = select_site.value;
        const siteUrl = siteMap[selectedValue];
        
        redeemPointsOnline(selectedValue, pts)
            .then(data => {
                const code = data.cardNo;
                couponCodeEl.textContent = code;
                
                couponMeta.textContent = `Valid at: ${new URL(siteUrl).hostname} • Value: ${formatNumber(egp)} EGP`;
                couponLink.href = siteUrl;
                showElements(couponBox);
                hideElements(storeBox);
                
                state.balance -= pts;
                state.pointsEarned -= pts;
                refreshTop(data.newBalance);
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }
    
    redeemPointsInput.value = '';
    totalValSpan.textContent = '0';
    hideElements(siteRow);
    selectByIndex(siteSelect, 0);
    validatePointsField();
});

copyCouponBtn.addEventListener('click', () => copyToClipboard(couponCodeEl.textContent.trim()));
copyStoreBtn.addEventListener('click', () => copyToClipboard(storeCodeEl.textContent.trim()));

document.getElementById('close-coupon-box')?.addEventListener('click', () => {
    hideElements(couponBox, siteRow);
    selectByIndex(siteSelect, 0);
    validatePointsField();
});

document.getElementById('close-store-box')?.addEventListener('click', () => {
    hideElements(storeBox);
    validatePointsField();
});



// Transfer Events - Single consolidated handler
checkBtn.addEventListener('click', () => {
    const num = (phoneInput.value || '').trim();


    if (!/^(?:01[0-2,5][0-9]{8}|201[0-2,5][0-9]{8})$/.test(num)) {
        statusP.textContent = "⚠️ Please enter a valid mobile number.";
        state.recipient = { checked: false, phone: '', registered: false };
        hideElements(nameRow, notRegAlert, btnTransfer, ptsInputFriend, transferTotalRow);
        updateTransferCTA();
        return;
    }

    let same_num = document.getElementById('pointsEarnedDisplay').getAttribute('data-phone');

    if (same_num == num) {
        statusP.textContent = "⚠️ You cannot transfer points to yourself.";
        state.recipient = { checked: false, phone: '', registered: false };
        hideElements(nameRow, notRegAlert, btnTransfer, ptsInputFriend, transferTotalRow);
        updateTransferCTA();
        return;
    }
   
    
     getRegistration(num)
    .then(result => {
        return result; 
    })
    .then(r => {

       
        state.recipient.checked = true;
        state.recipient.phone = num;
        state.recipient.registered = !!r.registered;
        
        if (state.recipient.registered) {
            const rawName = (r && r.name) ? r.name : '';
            const masked = maskName(rawName || state.recipient.phone || 'Customer');
            
            state.recipient.name = rawName;
            state.recipient.nameMasked = rawName;
            state.friendLookupDemo[num] = rawName;
            
            statusP.innerHTML = `Recipient: <strong>${rawName}</strong> ✅ Enter points to proceed.`;
            hideElements(nameRow, notRegAlert, nameErr);
        } else {
            statusP.textContent = "⚠️ This number is not registered in our system.";
            state.recipient = { checked: false, phone: '', registered: false };
            hideElements(nameRow, notRegAlert, btnTransfer, ptsInputFriend, transferTotalRow);
            updateTransferCTA();
            return;
            // showElements(nameRow, notRegAlert);
            // state.recipient.name = '';
            // state.recipient.nameMasked = '';
        }
        
        showElements(btnTransfer, ptsInputFriend, transferTotalRow);
        updateTransferCTA();

        
    })
    .catch(error => {
        console.error("Error in chain:", error);
    });
    

    
    
    
});

ptsInputFriend.addEventListener('input', () => {
    const ptsInputFriend = document.getElementById('transferPoints2');
    let pts = parseInt(ptsInputFriend.value || '0', 10);
    if (isNaN(pts)) pts = 0;
    
    if (!validateMinimumPoints(pts, state.minTransfer, errFriend, `Minimum transfer is ${state.minTransfer} points.`)) {
        transferValueEl.textContent = '0';
        updateTransferCTA();
        return;
    }

    pts = clampToBalance(pts, ptsInputFriend, errFriend);
    transferValueEl.textContent = formatNumber(pts);
    updateTransferCTA();
});

nameInput.addEventListener('input', updateTransferCTA);

btnTransfer.addEventListener('click', () => {


    const name_masked = document.querySelector('#transfer-status2 strong'); 

    if (!validateFriendPoints()) return;
    const pts = parseInt(ptsInputFriend.value, 10);

    const num = phoneInput.value.trim();

    const name =  name_masked.textContent.trim() || 'Recipient';
    
    document.getElementById('confirm-transfer-msg').textContent =
        `Send ${formatNumber(pts)} points to ${name}? (Value: ${formatNumber(pts)} EGP)`;
    showElements(document.getElementById('confirm-bar-transfer'));
});

document.getElementById('confirm-transfer-cancel').addEventListener('click', () => {
    hideElements(document.getElementById('confirm-bar-transfer'));
});

document.getElementById('confirm-transfer-yes').addEventListener('click', () => {
    hideElements(document.getElementById('confirm-bar-transfer'));
    
    const pts = parseInt(ptsInputFriend.value, 10);
    const num = phoneInput.value.trim();
    const name = nameInput.value.trim() || 'Recipient';
    
    state.balance -= pts;
    state.pointsEarned -= pts;
    
    resFriend.textContent = `Transferred ${formatNumber(pts)} points to ${name} (${num}) successfully.`;
    showElements(resFriend);

     transferPoints(num, pts).then(data => {
            resetFriendTransferForm();
           refreshTop(data.newBalance);
            setTimeout(() => {
                hideElements(resFriend);
                resFriend.textContent = '';
            }, 5000);
    })
    .catch(error => {
        console.error("Error:", error);
    });
    
});

// Notification Events
btnClearAll?.addEventListener('click', () => {
    if (!notifyList) return;
    notifyList.querySelectorAll('div[data-close]').forEach(item => {
        let id_close = item.getAttribute('data-close');
        markAsNotified(id_close, item);
        notifyList.innerHTML = '';
    });
    setBadgeCount(0);
});

notifyDropdown?.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('.notify-close');
    if (!closeBtn) return;
    e.preventDefault();
    
    const item = closeBtn.closest('a.dropdown-item') || closeBtn.closest('div');
    if (item?.parentElement) {
        markAsNotified(closeBtn.getAttribute('data-close'), item);
    }
});

// Navigation Events
document.querySelectorAll('.dd-action').forEach(item => {
    item.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelectorAll('[data-hide]').forEach(div => div.classList.add('hidden'));
        document.querySelectorAll('.dd-action').forEach(div => div.classList.remove('active'));
        item.classList.add('active');
        
        const targetId = item.getAttribute('data-show-item');
        document.querySelectorAll('#' + targetId).forEach(itm => {
            if (itm) itm.classList.remove('hidden');
        });
        
        resetFriendTransferForm();
    });
});

// ========== INITIALIZATION ==========
// Bind digit-only inputs
bindDigitsOnly('transferPhone2');
bindDigitsOnly('walletPhone');
bindDigitsOnly('bankAccount');
bindDigitsOnly('transferPoints2');
bindDigitsOnly('cashPoints');
bindDigitsOnly('redeemPoints');

// Initial validation
// validatePointsField();

// ========== PRIVACY/VISIBILITY FUNCTIONS ==========
(function() {
    try {
        const couponBox = document.getElementById('coupon-box');
        const storeBox = document.getElementById('store-box');
        const resultMsg = document.getElementById('result-msg');
        const confirmBar = document.getElementById('confirm-bar');
        const btnStore = document.getElementById('btn-store');
        const btnCoupon = document.getElementById('btn-coupon');
        const toast = document.getElementById('np-toast');
        
        function isVisible(el) {
            if (!el) return false;
            const style = window.getComputedStyle(el);
            return !(el.classList.contains('np-hidden') || 
                    style.display === 'none' || 
                    style.visibility === 'hidden');
        }
        
        function showToast(msg) {
            if (!toast) return;
            if (msg) toast.textContent = msg;
            toast.style.opacity = '1';
            clearTimeout(showToast._t);
            showToast._t = setTimeout(() => { toast.style.opacity = '0'; }, 1800);
        }
        
        function hideRedeemOutputsPrivacy() {
            let hiddenAny = false;
            [couponBox, storeBox, resultMsg, confirmBar].forEach(el => {
                if (el && isVisible(el)) {
                    el.classList.add('np-hidden');
                    hiddenAny = true;
                }
            });
            if (hiddenAny) showToast('Hidden for your privacy');
        }
        
        if (btnStore) btnStore.addEventListener('click', hideRedeemOutputsPrivacy);
        if (btnCoupon) btnCoupon.addEventListener('click', hideRedeemOutputsPrivacy);
        
        document.addEventListener('click', (e) => {
            let t = e.target;
            while (t && t !== document) {
                if (t.classList && t.classList.contains('dd-action')) {
                    hideRedeemOutputsPrivacy();
                    break;
                }
                t = t.parentNode;
            }
        }, { capture: true });
        
        function ensureTimer(el) {
            if (!el || el.__np_timer) return;
            el.__np_timer = setTimeout(() => {
                if (isVisible(el)) {
                    el.classList.add('np-hidden');
                    showToast('Hidden for your privacy');
                }
                el.__np_timer = null;
            }, 20000);
        }
        
        function clearTimer(el) {
            if (el && el.__np_timer) {
                clearTimeout(el.__np_timer);
                el.__np_timer = null;
            }
        }
        
        setInterval(() => {
            [couponBox, storeBox].forEach(el => {
                if (!el) return;
                if (isVisible(el)) {
                    ensureTimer(el);
                } else {
                    clearTimer(el);
                }
            });
        }, 500);
    } catch (e) {}
})();



    document.querySelectorAll('.dd-action').forEach(item => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelectorAll('[data-hide]').forEach(div => div.classList.add('hidden'));
            document.querySelectorAll('.dd-action').forEach(div => div.classList.remove('active'));
            item.classList.add('active');
            const targetId = item.getAttribute('data-show-item');
            document.querySelectorAll('#' + targetId).forEach(itm => { if (itm) itm.classList.remove('hidden'); });
            if(targetId == 'points-activity'){
                initExampleTable();
            }
            

            phoneInput.value = '';
            nameInput.value = '';
            ptsInputFriend.value = '';
            statusP.textContent = '';
            btnTransfer.disabled = true;
            ptsInputFriend.classList.add('np-hidden'); 
            btnTransfer.classList.add('np-hidden'); 
            nameRow.classList.add('np-hidden');
            transferTotalRow.classList.add('np-hidden');     
        });
    });
